import React, { Component } from 'react';
import DefaultNavbar from '../navigation/defaultnavbar.jsx'
import Activate from './activate.jsx'
import '../../stylesheet/activate.css'

class componentName extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <DefaultNavbar />
                    </div>

                </div>
                <div className="container" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="offset-md-1 col-sm-10" style={{ padding: "12px" }}>
                            <Activate />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default componentName;


// WEBPACK FOOTER //
// ./src/components/register/navactivate.jsx